export default "__VITE_ASSET__DKTHcqSr__"